import { render, staticRenderFns } from "./materialListByTag.vue?vue&type=template&id=3ee39451&scoped=true&"
import script from "./materialListByTag.vue?vue&type=script&lang=js&"
export * from "./materialListByTag.vue?vue&type=script&lang=js&"
import style0 from "./materialListByTag.vue?vue&type=style&index=0&id=3ee39451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee39451",
  null
  
)

export default component.exports